<script>
	import Header from "./Header.svelte";
	import About from "./About.svelte";
	import Commodity from "./Commodity.svelte";
	import Team from "./Team.svelte";
	import Order from "./Order.svelte";
	import Values from "./Values.svelte";
	import Registered from "./Registered.svelte";
	import Footer from "./Footer.svelte";
	import Menu from "./cMenu.svelte";
	import Ads from "./cAds.svelte";
	import Visit from "./cVisit.svelte";
</script>

<main>

<Header/>
<About/>
<!-- <Commodity/> -->
<Menu/>
<Order/>
<Values/>
<Team/>
<Registered/>
<Footer/>
</main>

<style>
	 main {
		width: 100%;
	}

	/* h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */
</style>